<template>
    <div class="wrapper">
        <div class="topo-header centro">
            <botao-voltar nomeRota="Membro" />
            <h1>{{ membroForm.id ? "Editar" : "Novo" }} Membro</h1>
        </div>
        <div class="tab-dados-basicos">
            <div class="form centro">
                <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
                <p class="texto-asterisco">Os campos com asterisco (*) são de preenchimento obrigatório.</p>
                <form @submit.prevent="enviarForm">
                    <div class="caixa-form">
                        <div class="flexbox-2">
                            <div class="item">
                                <label><b>{{ possuiAsterisco("CPF:") }}</b></label>
                                <the-mask :mask="['###.###.###-##']" placeholder="Digite o CPF" v-model="membroForm.cpf"/>
                            </div>
                            <div class="item">
                                <button id="btn-carregar-dados" class="btn-carregar-dados" @click.prevent="buscarDados(membroForm.cpf)">
                                    <img id="spinner-loading-carregar" class="spinner-loading"
                                        src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                                    <p id="conteudo-botao-carregar">Carregar Dados</p>
                                </button>
                            </div>
                            <div class="item">
                                <label><b>{{ possuiAsterisco("Nome:") }}</b></label>
                                <input type="text" placeholder="Digite o nome" v-model="membroForm.nome" />
                            </div>
                            <!-- Apenas exibe a opção Servidor Público após o carregamento dos dados -->
                            <div class="item">
                                <div class="radio">
                                    <label class="radio-label"><b>{{ possuiAsterisco("Servidor Público?") }}</b></label>
                                    <div class="radio-item">
                                        <div class="options">
                                            <label for="sim-servidor">Sim</label>
                                            <input type="radio" id="sim-servidor" name="radioOptions" value="true" v-model="membroForm.servidor_publico" disabled>
                                        </div>
                                        <div class="options">
                                            <label for="nao-servidor">Não</label>
                                            <input type="radio" id="nao-servidor" name="radioOptions" value="false" v-model="membroForm.servidor_publico" disabled>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bt-salvar">
                        <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                            <img id="spinner-loading" class="spinner-loading" src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                            <p id="conteudo-botao">{{ membroForm.id ? "Atualizar" : "Criar" }}</p>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="modalConfirmacaoAtualizacaoVisivel" class="modal-exclusao">
            <div class="modal-mask">
                <div class="modal-container">
                    <div class="modal-header">
                        <h2>Deseja realmente atualizar este membro?</h2>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-confirmar-exclusao" @click="confirmarAtualizacaoMembro">Sim</button>
                        <button class="btn-cancelar-exclusao" @click="fecharModalConfirmacaoAtualizacao">Não</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MembroApi from '../../services/MembroApi';
    import BotaoVoltar from '../../components/BotaoVoltar.vue';
    import MsgErroFormularios from '../MsgErroFormularios';

    export default {
        name: 'MembroForm',
        props: {
            membro: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {
                carregando: false,
                erro: false,
                verificarCarregamento: false,
                modalConfirmacaoAtualizacaoVisivel: false,
                msgErros: {
                    cpf: '',
                    servidor_publico: '',
                    nome: '',
                    default: '',
                },
                membroApi: null,
                membroForm: this.membro
                    ? {
                        id: this.membro.id,
                        cpf: this.membro.cpf,
                        servidor_publico: this.membro.servidor_publico,
                        nome: this.membro.nome, 
                    }
                    : {
                        id: null,
                        cpf: null,
                        servidor_publico: null,
                        nome: null,
                    },
            };
        },
        components: {
            BotaoVoltar,
            MsgErroFormularios,
        },
        created() {
            this.membroApi = new MembroApi();
        },
        methods: {
            abrirModalConfirmacaoAtualizacao() {
                this.modalConfirmacaoAtualizacaoVisivel = true;
            },

            fecharModalConfirmacaoAtualizacao() {
                this.modalConfirmacaoAtualizacaoVisivel = false;
            },

            confirmarAtualizacaoMembro() {
                this.modalConfirmacaoAtualizacaoVisivel = false;
                this.prosseguirEnvioForm();
            },
            enviarForm() {

                if (this.membroForm.id) {
                    this.abrirModalConfirmacaoAtualizacao();
                } else {
                    this.prosseguirEnvioForm(); 
                }
            },
            async prosseguirEnvioForm() {
                this.erro = false;

                if (this.membroForm.id && this.membroForm.cpf !== this.membro.cpf && !this.verificarCarregamento) {
                    this.erro = true;
                    this.msgErros.default = 'Por favor, clique em "Carregar Dados" antes de enviar o formulário.';
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return false;
                }

                try {
                    const flag = this.validarForm(this.membroForm);
                    if (flag === 1) {
                        this.erro = true;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        return false;
                    }

                    this.carregando = true;
                    const data = await this.membroApi.setMembro(this.membroForm);
                    this.$router.push({
                        name: 'MembroShow',
                        params: { id: data.id },
                    });
                } catch (err) {
                    console.error(err);
                    this.erro = true;
                    const { response } = err;
                    if (response && response.data) {
                        this.msgErros = response.data;
                    } else {
                        this.msgErros = 'Houve um erro ao salvar o registro. Por favor, tente novamente.';
                    }
                } finally {
                    this.carregando = false;
                }
                if (this.membroForm.servidor_publico === null) {
                    // Define o valor do servidor como "Não"
                    this.membroForm.servidor_publico = "false";
                }
                
            },
            async buscarDados(cpf) {
                this.erro = false;
                this.verificarCarregamento = true;
                try {
                    this.carregando = true;
                    const dados = await this.membroApi.getDadosRhNet(cpf);
                    if (dados && Object.keys(dados).length !== 0) {
                        // Se os dados forem encontrados, atualize o nome do membro
                        this.membroForm.nome = dados.nome;
                        // Defina o status do servidor como "Sim"
                        this.membroForm.servidor_publico = 'true';
                    } 
                } catch (err) {
                    this.membroForm.servidor_publico = 'false';

                        console.log(err);
                        this.carregando = false;
                        this.erro = true;


                        const { response } = err;
                        if (response && response.data) {
                            this.msgErros = response.data.mensagem;
                        } else {
                            this.msgErros =
                                "Houve um erro ao salvar o registro. Por favor tente novamente.";
                        }
                    }
                    if (this.membroForm.servidor_publico === null) {
                        // Define o valor do servidor como "Não"
                        this.membroForm.servidor_publico = "false";
                    }     
            },
            validarForm(membroForm) {
                let flag = 0;
                // Resetar as mensagens de erro
                this.msgErros = {
                    cpf: '',
                    servidor_publico: '',
                    nome: '',
                    default: '',
                };

                // Verificar se o CPF está preenchido
                if (!membroForm.cpf) {
                    this.msgErros.cpf = 'O campo CPF não foi preenchido.';
                    flag = 1;
                }
                //CPF tem que ser válido
                if(!this.validarCPF(membroForm.cpf)){
                    this.msgErros.cpf = "CPF inválido.";
                    flag = 1;
                }
                if (this.membroForm.servidor_publico === null) {
                        // Define o valor do servidor como "Não"
                        this.membroForm.servidor_publico = "false";
                }    
                if (!membroForm.nome) {
                    this.msgErros.nome = 'O campo nome não foi preenchido.';
                    flag = 1;
                }
                return flag;
            },
            validarCPF(cpf) {
                cpf = cpf.replace(/\D/g, '');
                if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) {
                    return false;
                }

                let soma = 0;
                let resto;

                for (let i = 1; i <= 9; i++) {
                    soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
                }
                resto = (soma * 10) % 11;

                if (resto === 10 || resto === 11) resto = 0;
                if (resto !== parseInt(cpf.charAt(9))) {
                    return false;
                }

                soma = 0;
                for (let i = 1; i <= 10; i++) {
                    soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
                }
                resto = (soma * 10) % 11;

                if (resto === 10 || resto === 11) resto = 0;
                if (resto !== parseInt(cpf.charAt(10))) {
                    return false;
                }

                return true;
            },
            possuiAsterisco(texto) {
                return '* ' + texto;
            },
            fecharErro() {
                this.erro = false;
            },
        },
    };
</script>

<style lang="scss" scoped>
@import "../../styles/catalogoForm.scss";

/*  ESTILOS DO MODAL DE ATUALIZAÇÃO */
.modal-exclusao {
  position: fixed !important;
  z-index: 10000 !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
  display: flex !important; 
  align-items: center !important; 
  justify-content: center !important; 
  transition: opacity 0.3s ease !important;

  .modal-mask {
    border-radius: 1rem !important;
    position: relative !important;
    z-index: 10000 !important;
    width: auto !important; 
    min-width: 400px !important;
    max-width: 90vw !important;
    background-color: #f2f2f2 !important;
    display: flex !important; 
    flex-direction: column !important; 
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3) !important;
    margin: auto !important;
  }

  .modal-container {
    padding: 1.5rem 2rem !important;
    display: flex !important;
    flex-direction: column !important;
    height: auto !important;
    font-family: "Montserrat-Medium", sans-serif !important;

    .modal-header {
      margin-bottom: 1.5rem !important;
      h2 {
        font-size: 1.3rem !important;
        font-weight: bold !important;
        text-align: center !important;
        margin: 0 !important;
        color: #333 !important;
      }
    }

    .modal-footer {
      display: flex !important;
      justify-content: center !important;
      margin-bottom: 0 !important;
      gap: 1.5rem !important;

      .btn-confirmar-exclusao {
        border: none !important;
        border-radius: .5rem !important;
        width: 120px !important;
        height: 2.5rem !important;
        background-color: #005516 !important;
        color: #ffffff !important;
        font-weight: bold !important;
        font-size: 1rem !important;
        cursor: pointer !important;
        transition: 0.2s !important;
        &:hover { background-color: #003a0f !important; }
      }

      .btn-cancelar-exclusao {
        border: none !important;
        border-radius: .5rem !important;
        width: 120px !important;
        height: 2.5rem !important;
        background-color: #bd0000 !important;
        color: #ffffff !important;
        font-weight: bold !important;
        font-size: 1rem !important;
        cursor: pointer !important;
        transition: 0.2s !important;
        &:hover { background-color: #8c0000 !important; }
      }
    }
  }
}
.wrapper .form.centro p.texto-asterisco {
  color: #005516 !important;
  font-size: 0.9rem !important;
  margin-bottom: 1rem !important;
  font-family: "Montserrat-Medium", sans-serif !important;
}
/* Organizar os radio buttons em coluna (abaixo do título) e alinhar à esquerda */
.caixa-form .radio {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  width: 100% !important;
  gap: 1rem !important;
}

.caixa-form .radio-label {
  margin: 0 !important;
  text-align: left !important;
  width: 100% !important;
}

.caixa-form .radio-item {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 0.8rem !important; /* Espaçamento entre Sim e Não */
}

.caixa-form .radio-item .options {
  display: flex !important;
  align-items: center !important;
}

.caixa-form .radio-item .options input {
  margin: 0 !important;
  width: auto !important;
}

.caixa-form .radio-item .options label {
  margin: 0 0.3rem 0 0 !important; /* Inverte a margem: primeiro a palavra, depois a bolinha */
  font-size: 0.85rem !important;
}

/* Divide o espaço em 4 colunas preenchendo 100% da largura do card */
.caixa-form .flexbox-2 {
  display: grid !important;  
  grid-template-columns: 1fr max-content 2fr max-content !important;
  align-items: flex-end !important; /* Alinha o botão pela base das caixas de texto */
  gap: 1.5rem !important;
  width: 90% !important;
}

/* Garante que os itens ocupam o espaço da coluna que receberam */
.caixa-form .flexbox-2 .item {
  margin: 0 !important;
  width: 100% !important;
}

/* Ajuste fino para o botão Carregar Dados ficar na mesma linha da caixa do CPF */
.caixa-form .flexbox-2 .item:nth-child(2) button {
  margin-bottom: 0.15rem !important;
  height: 2.55rem !important; 
}

</style>
